import { Core } from 'chessboard/core/config/types';

/**
 * Determine if an event is an API event.
 */
export function isAPIEvent(event: Core.Event) {
  return Object.values(Core.APIEvents).includes(event.type);
}
